import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const OutOfRangeTooltip = () => {
  const { t } = useTranslation()

  return (
    <TooltipBase>
      {t(
        'The position is inactive and not earning trading fees due to the current price being out of the set price range.',
      )}
    </TooltipBase>
  )
}
